<div class="top-header-spacer"></div>
<nav
  #topHeader
  class="top-nav navbar navbar-expand w-100 p-0 d-flex flex-column"
>
  <div
    class="d-flex justify-content-between align-items-center pr-2 w-100 h-100 border-bottom"
  >
    <epc-brand-indicator></epc-brand-indicator>

    <epc-basket-button class="nav-item ml-auto"></epc-basket-button>
  </div>
</nav>

<div class="w-100">
  <ng-container
    *epcFeatureFlag="
      bannerEnabledFeatureKey;
      namespace: pulseNamespace;
      equality: true;
      defaultValue: false
    "
  >
    <router-outlet></router-outlet>
  </ng-container>
</div>

<epc-secondary-navigation-bar></epc-secondary-navigation-bar>

@if ({ showSearchBarOnMobile: showSearchBarOnMobile$ | async, isMobile:
isMobile$ | async }; as observables) { @if (observables.isMobile ?
observables.showSearchBarOnMobile : true) {
<epc-search-bar class="d-block mx-2 mt-2"></epc-search-bar>
} }

<nav
  #bottomheader
  class="bottom-nav navbar justify-content-between navbar-expand w-100 border-top"
>
  <epc-nav-link
    class="nav-item h-100"
    [listGroupAction]="false"
    [label]="mobileListsLink.label"
    [route]="mobileListsLink.route"
    [name]="mobileListsLink.name"
    [queryParams]="
      mobileListsLink.appendSearchParams
        ? (searchQueryParams$ | async)
        : undefined
    "
    [isActive]="mobileListsLink.isActive$ | async"
    [icon]="bookmarkIcon$ | async"
    [iconOnly]="true"
    hostClassList="bottom light"
  ></epc-nav-link>
  <epc-nav-link
    class="nav-item h-100"
    [listGroupAction]="false"
    [label]="productsLink.label"
    [route]="productsLink.route"
    [name]="productsLink.name"
    [queryParams]="
      productsLink.appendSearchParams ? (searchQueryParams$ | async) : undefined
    "
    [isActive]="productsLink.isActive$ | async"
    [icon]="productsLink.icon"
    [iconOnly]="true"
    hostClassList="bottom light"
  ></epc-nav-link>
  @if (scannerEnabled$ | async) {
  <epc-nav-link
    class="nav-item h-100"
    [listGroupAction]="false"
    [label]="scannerLink.label"
    [route]="scannerLink.route"
    [name]="scannerLink.name"
    [queryParams]="
      scannerLink.appendSearchParams ? (searchQueryParams$ | async) : undefined
    "
    [isActive]="scannerLink.isActive$ | async"
    [icon]="scannerLink.icon"
    [iconOnly]="true"
    hostClassList="bottom light"
  ></epc-nav-link>
  }

  <div class="user-menu-wrapper">
    <epc-user-menu-widget></epc-user-menu-widget>
  </div>
</nav>

<epc-user-contacts class="d-none"></epc-user-contacts>
